import a from "@material-ui/core/styles/createStyles";
const t = (o) => a({
  caption: {
    margin: "0.5",
    color: "white",
    textAlign: "center"
  },
  imageContainer: {
    position: "relative",
    margin: "0 auto",
    display: "table",
    overflow: "hidden",
    borderRadius: 6
  },
  modalImage: {
    maxHeight: "calc(100vh - 150px)",
    maxWidth: "100%",
    margin: "auto",
    [o.breakpoints.down("md")]: {
      maxHeight: "calc(100vh - 75px)"
    }
  },
  overlay: {
    position: "absolute",
    top: 0,
    padding: "0.5em 1em",
    fontWeight: "bold",
    color: "#fff",
    background: "rgba(0, 0, 0, 0.75)",
    borderRadius: 6,
    margin: 1
  }
});
export {
  t as styles
};
//# sourceMappingURL=CarouselSlider.styles.js.map
